export function getRgbLuma(red, green, blue) {
  return (
    0.2126 * parseInt(red, 16) +
    0.7152 * parseInt(green, 16) +
    0.0722 * parseInt(blue, 16)
  );
}
